import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { ModalLayout } from '../../../modal';
import { WarningBox } from '../warning-box';
import { StyledExclamationIcon, StyledMessage } from './user-actions-modal.styles';
import { UserActionModalProps } from './user-actions-modal.types';
export const UserActionsModal = ({
  titleText,
  actionButtonText,
  message,
  warningBoxText,
  open,
  openChange,
  handleModalAction
}: UserActionModalProps) => <ModalLayout open={open} openChange={openChange} showTriggerElement={false} modalTitleText={titleText} customHeaderIcon={<StyledExclamationIcon icon={faExclamationCircle} />} closeButtonText="Cancel" actionButtonText={actionButtonText} actionButtonColor="error" showWarnBox={false} handleActionButton={handleModalAction} data-sentry-element="ModalLayout" data-sentry-component="UserActionsModal" data-sentry-source-file="user-actions-modal.tsx">
    <StyledMessage data-sentry-element="StyledMessage" data-sentry-source-file="user-actions-modal.tsx">{message}</StyledMessage>
    <WarningBox warningText={warningBoxText} data-sentry-element="WarningBox" data-sentry-source-file="user-actions-modal.tsx" />
  </ModalLayout>;